import { RequestServices } from '../services/request.service';
import { Configuration } from '../Constants/configuration';
import { StorageService } from '../services/storage.service';
import { Observable, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { CocheSeguro } from '../modelos/cocheSeguro.model';

export class LogConsumoFunciones {
    private subject = new Subject<any>();
    public const: Configuration = new Configuration();
    public logConsumoId: string = "";
    public cocheSeguro: CocheSeguro = new CocheSeguro();

    constructor(
        private requestService?: RequestServices,
        private storageService?: StorageService,
        private router?: Router
    ) { }


    ayudaInsert(): Observable<any> {
        try {
            let data = {
                "v1": this.storageService.getItem("logConsumoId"),
                "paso": this.getPaso(),
                "masterJson": this.storageService.getItem("cocheSeguro")
            };
            this.requestService.postRequest({ projectName: this.const.WEB_DB_AES, apiName: "Sio4InsertAyudaAPI", dataJSON: data }).subscribe(result => {
                if (result.error) {
                    this.subject.next(result);
                    console.error("requestService.get", result.error);
                } else if (result.ok || result.Exist_log) {
                    this.subject.next(result);
                    // [BEGIN registrar en Firebase]
                    let cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
                    let payload = {
                        "socio_id": this.const.SOCIOQUATTRO,
                        "log_consumo_id": this.storageService.getItem("logConsumoId"),
                        "contratante": cocheSeguro.contratante?.nombres + ' ' + cocheSeguro.contratante?.ap_pat + ' ' + cocheSeguro.contratante?.ap_mat
                    };
                    let _data = {
                        "payload": JSON.stringify(payload)
                    }

                    this.requestService.postRequest({ projectName: this.const.CLOUD_FIRESTORE_AES_URL, apiName: 'InterAutosSolicitudAyudaEventService', dataJSON: _data }).subscribe(
                        res => {
                            console.log('InterAutosSolicitudAyudaEventService', res);
                        },
                        err => {
                            console.error("InterAutosSolicitudAyudaEventService.error", err);
                        }
                    );
                    // [END registrar en Firebase]
                } else {
                    this.subject.next(result);
                    console.log("else.logConsumo.ayudaInsert", result);
                }
            });
        } catch (error) {
            this.subject.next(error);
            console.error(error);
        }
        return this.subject.asObservable();
    }

    getLogJSON(logConsumoID): Observable<any> {
        let parameters: any = [{ "f1": logConsumoID }];
        try {
            this.requestService.getRequest({ projectName: this.const.WEB_DB_AES, apiName: "Sio4GetJsonLogConsumoAPI", params: parameters }).subscribe(result => {
                if (result.error) {
                    this.subject.next(result);
                    console.error("requestService.get", result.error);
                } else if (result.json) {
                    this.subject.next(result);
                } else {
                    this.subject.next(result);
                    console.log("else.logConsumo.getLogJSON", result);
                }
            });
        } catch (error) {
            this.subject.next(error);
            console.error(error);
        }
        return this.subject.asObservable();
    }

    logConsumo(datos?: any, carrusel?: number) {

        try {
            if (this.storageService.ifExist("logConsumoId")) {
                const log = JSON.parse(JSON.stringify({ "id": this.storageService.getItem("logConsumoId") }));
                // UPDATE PARA LOGCONSUMO

                let lconsumo: LogConsumo = new LogConsumo();
                this.cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));

                let paquete: string = "";

                switch (this.cocheSeguro.paquete) {
                    case 0: // AMPLIA
                        paquete = "AMPLIA";
                        break;
                    case 1: // LIMITADA
                        paquete = "LIMITADA";
                        break;
                    case 2: // BÁSICA
                        paquete = "BÁSICA";
                        break;
                }

                lconsumo.v1 = "94c3qaBTlOBbdUWPBkxEmg==";
                lconsumo.v2 = (this.cocheSeguro?.prospecto?.correo) ? this.cocheSeguro.prospecto.correo : "";
                lconsumo.v3 = (this.cocheSeguro?.prospecto?.nombre) ? this.cocheSeguro.prospecto.nombre : "";
                lconsumo.v4 = (this.cocheSeguro?.prospecto?.cp) ? this.cocheSeguro.prospecto.cp : "";
                lconsumo.v5 = (this.cocheSeguro?.dataVehiculo) ? this.cocheSeguro.dataVehiculo.multicotiza.f4 : 0;
                lconsumo.v6 = (this.cocheSeguro?.dataVehiculo) ? this.cocheSeguro.dataVehiculo.multicotiza.f3 : '';
                lconsumo.v7 = (this.cocheSeguro?.dataVehiculo) ? this.cocheSeguro.dataVehiculo.datosAuto.descripcion : '';
                lconsumo.v8 = paquete;
                lconsumo.v9 = (this.cocheSeguro?.origen) ? this.cocheSeguro.origen : 0;
                lconsumo.v15 = (this.cocheSeguro?.dataVehiculo) ? this.cocheSeguro.dataVehiculo.datosAuto.tipoUnidad+'' : '0';
                if (lconsumo.v15 === 'undefined'){
                    lconsumo.v15 = '0';
                }
                if (carrusel != undefined) {
                    lconsumo.v10 = carrusel;

                } else {

                    lconsumo.v10 = 0;
                }
                setTimeout(() => {
                    let data = {
                        "logConsumoId": log.id ? log.id : '',
                        "paso": this.getPaso(datos),
                        "masterJson": this.storageService.getItem("cocheSeguro"),
                        "datos": lconsumo
                    }
                    this.requestService.postRequest({ projectName: this.const.WEB_DB_AES, apiName: "Sio4UpdateLogConsumoAPI", dataJSON: data }).subscribe(result => {
                        if (result.error) {
                            console.error("requestService.get", result.error);
                        } else if (result.ok) {

                        } else {
                            console.log("else.logConsumo.logConsumoUpdate", result);
                        }
                    });
                }, 400);

            } else { // INSERT PARA LOGCONSUMO 

                this.requestService.postRequest({ projectName: this.const.WEB_DB_AES, apiName: "Sio4InsertLogConsumoAPI", dataJSON: datos }).subscribe(result => {
                    if (result.error) {
                        console.error("requestService.get", result.error);
                    } else if (result.ok) {
                        this.logConsumoId = result.c1;
                        this.storageService.setItem("logConsumoId", this.logConsumoId);
                        if (this.storageService.ifExist("cocheSeguro")) {
                            this.cocheSeguro = JSON.parse(this.storageService.getItem("cocheSeguro"));
                            this.cocheSeguro.correoEnviadoFE = false;
                            this.storageService.setItem("cocheSeguro", JSON.stringify(this.cocheSeguro));
                        }

                    } else {
                        //console.log("else.logConsumo.logConsumoInsert", result);
                    }
                });
            }

        } catch (error) {
            this.subject.next(false)
            console.error("Error", error);
        }
    }

    getPaso(urlPaso?: number): number {
        let paso: number = 0;
        try {
            if (urlPaso && urlPaso !== 0) {
                paso = urlPaso;
            } else {

                switch (this.router.url.split("?")[0]) {
                    case '/inicio':
                        paso = 1;
                        break;
                    case '/cotizacion/inicio':
                        paso = 2;
                        break;
                    case '/datos-emision':
                        paso = 3;
                        break;
                    case '/datos-emision-vehiculo':
                        paso = 4;
                        break;
                    case '/datos-tarjeta':
                        paso = 5;
                        break;
                    case '/mi-cuenta/inicio':
                        paso = 6;
                        break;
                    default:
                        paso = 1;
                        break;
                }
            }

        } catch (error) {
            console.error("error", error);
        }
        return paso;
    }

}

export class LogConsumo {
    public v1: string;//INTERAUTOS ES PRODUCTO_ID 1
    public v2: string;
    public v3: string;
    public v4: string;
    public v5: number;
    public v6: string;
    public v7: string;
    public v8: string;
    public v9: number;
    public v10: number;
    public v11?: string; // fuente
    public v12?: string; // campania
    public v13?: string; // contenido
    public v14?: string; //medio
    public v15?: string; // tipo de unidad

}